import { deepMap } from "../object";
import { testAllRegex } from "../regex";
import { maskString } from "./maskString";
import { PII_PATTERNS_KEY, PII_PATTERNS_VALUE } from "./piiRegex";

export const piiSanitize = (data: unknown) => {
  return deepMap(data, (key, value) => {
    if (typeof value === "string") {
      if (
        testAllRegex(key, PII_PATTERNS_KEY) ||
        testAllRegex(value, PII_PATTERNS_VALUE)
      ) {
        const truncated = value.slice(0, 16);
        return maskString(truncated, 4);
      }
    }

    return value;
  });
};
